export default {
      id: "Logo_header-usage",
      viewBox: "0 0 169 136",
      url: "../dist/images/" + "sprite.svg#Logo_header-usage",
      toString: function () {
        return this.url;
      }
    }